import { createAction, handleActions } from 'redux-actions';
import { _getServiceTypesList, _addNewServiceType, _editServiceType, _deleteServiceType } from '~shared/httpService/apis';
import ActionTypes from '~shared/constants/actionTypes';
import { _getServiceTypeByPagination } from '../../../shared/httpService/apis';

const initialState = {
  service_types: {
    loading: false,
    response: [],
    hasError: false,
    error: {}
  },
  add_new_service_type: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  edit_service_type: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  delete_service_type: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  paginated_service_types: {
    loading: false,
    response: [],
    hasError: false,
    error: {}
  },

};

export const getServiceTypesListStart = createAction(ActionTypes.GET_SERVICE_TYPES_LIST);
export const getServiceTypesListSuccess = createAction(ActionTypes.GET_SERVICE_TYPES_LIST_SUCCESS, response => response);
export const getServiceTypesListError = createAction(ActionTypes.GET_SERVICE_TYPES_LIST_ERROR, error => error);

export const getServiceTypesList = (page = '', pageSize, searchQuery) => (dispatch) => {
  dispatch(getServiceTypesListStart());
  return _getServiceTypesList(page, pageSize, searchQuery).then((response) => {
    dispatch(getServiceTypesListSuccess(response));
  }).catch((error) => {
    dispatch(getServiceTypesListError(error));
  });
};

export const addNewServiceTypeStart = createAction(ActionTypes.ADD_NEW_SERVICE_TYPE);
export const addNewServiceTypeSuccess = createAction(ActionTypes.ADD_NEW_SERVICE_TYPE_SUCCESS, response => response);
export const addNewServiceTypeError = createAction(ActionTypes.ADD_NEW_SERVICE_TYPE_ERROR, error => error);

export const addNewServiceType = (data) => (dispatch) => {
  let formdata = new FormData();
  formdata.append('name', data?.name);
  // formdata.append('indexValue', data?.indexValue);
  formdata.append('active', data?.active);
  formdata.append('file', data?.file);
  dispatch(addNewServiceTypeStart());
  return _addNewServiceType(formdata).then((response) => {
    dispatch(addNewServiceTypeSuccess(response));
  }).catch((error) => {
    dispatch(addNewServiceTypeError(error));
  });
};

export const editServiceTypeStart = createAction(ActionTypes.EDIT_SERVICE_TYPE);
export const editServiceTypeSuccess = createAction(ActionTypes.EDIT_SERVICE_TYPE_SUCCESS, response => response);
export const editServiceTypeError = createAction(ActionTypes.EDIT_SERVICE_TYPE_ERROR, error => error);

export const editServiceType = (id, data) => (dispatch) => {
  let formdata = new FormData();
  formdata.append('name', data?.name);
  if (data?.indexValue !== null) {
    formdata.append('indexValue', data?.indexValue);
  }
  formdata.append('active', data?.active);
  if (data?.file)
    formdata.append('file', data?.file);
  dispatch(editServiceTypeStart());
  return _editServiceType(id, formdata).then((response) => {
    dispatch(editServiceTypeSuccess(response));
  }).catch((error) => {
    dispatch(editServiceTypeError(error));
  });
};

export const deleteServiceTypeStart = createAction(ActionTypes.DELETE_SERVICE_TYPE);
export const deleteServiceTypeSuccess = createAction(ActionTypes.DELETE_SERVICE_TYPE_SUCCESS, response => response);
export const deleteServiceTypeError = createAction(ActionTypes.DELETE_SERVICE_TYPE_ERROR, error => error);

export const deleteServiceType = (id) => (dispatch) => {
  dispatch(deleteServiceTypeStart());
  return _deleteServiceType(id).then((response) => {
    dispatch(deleteServiceTypeSuccess(response));
  }).catch((error) => {
    dispatch(deleteServiceTypeError(error));
  });
};


export const getPaginatedServiceTypeStart = createAction(ActionTypes.PAGINATED_SERVICE_TYPE);
export const getPaginatedServiceTypeSuccess = createAction(ActionTypes.PAGINATED_SERVICE_TYPE_SUCCESS, response => response);
export const getPaginatedServiceTypeError = createAction(ActionTypes.PAGINATED_SERVICE_TYPE_ERROR, error => error);

export const getServiceTypeByPagination = (pageNo, pageSize, inputValue) => (dispatch) => {
  dispatch(getPaginatedServiceTypeStart());
  return _getServiceTypeByPagination(pageNo, pageSize, inputValue).then((response) => {
    dispatch( getPaginatedServiceTypeSuccess(response));
  }).catch((error) => {
    dispatch(getPaginatedServiceTypeError(error));
  });
};


const reducer = handleActions({

  //SERVICE_TYPES_LIST_PAGINATED
  [ActionTypes.PAGINATED_SERVICE_TYPE]: (state) => ({
    ...state,  paginated_service_types: {
      ...state. paginated_service_types,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.PAGINATED_SERVICE_TYPE_SUCCESS]: (state, action) => ({
    ...state,
    paginated_service_types: {
      ...state. paginated_service_types,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.PAGINATED_SERVICE_TYPE_ERROR]: (state, action) => ({
    ...state,
    paginated_service_types: {
      ...state. paginated_service_types,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),





  //SERVICE_TYPES_LIST
  [ActionTypes.GET_SERVICE_TYPES_LIST]: (state) => ({
    ...state, service_types: {
      ...state.service_types,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_TYPES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    service_types: {
      ...state.service_types,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_TYPES_LIST_ERROR]: (state, action) => ({
    ...state,
    service_types: {
      ...state.service_types,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //ADD_NEW_SERVICE_TYPE
  [ActionTypes.ADD_NEW_SERVICE_TYPE]: (state) => ({
    ...state,
    add_new_service_type: {
      ...state.add_new_service_type,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.ADD_NEW_SERVICE_TYPE_SUCCESS]: (state, action) => ({
    ...state,
    add_new_service_type: {
      ...state.add_new_service_type,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.ADD_NEW_SERVICE_TYPE_ERROR]: (state, action) => ({
    ...state,
    add_new_service_type: {
      ...state.add_new_service_type,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //EDIT_SERVICE_TYPE
  [ActionTypes.EDIT_SERVICE_TYPE]: (state) => ({
    ...state,
    edit_service_type: {
      ...state.edit_service_type,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.EDIT_SERVICE_TYPE_SUCCESS]: (state, action) => ({
    ...state,
    edit_service_type: {
      ...state.edit_service_type,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_SERVICE_TYPE_ERROR]: (state, action) => ({
    ...state,
    edit_service_type: {
      ...state.edit_service_type,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //DELETE_SERVICE_TYPE
  [ActionTypes.DELETE_SERVICE_TYPE]: (state) => ({
    ...state,
    delete_service_type: {
      ...state.delete_service_type,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.DELETE_SERVICE_TYPE_SUCCESS]: (state, action) => ({
    ...state,
    delete_service_type: {
      ...state.delete_service_type,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.DELETE_SERVICE_TYPE_ERROR]: (state, action) => ({
    ...state,
    delete_service_type: {
      ...state.delete_service_type,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
}, initialState);

export default reducer;